import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import * as constants from '../_model/string_literal';
import { tokenResponse } from '../_model/meetings';

@Injectable({
  providedIn: 'root'
})
export class MeetingsService {
  roomName!: string;
  LIVEKIT_URL = constants.LIVEKIT_URL;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    const parsedToken = token ? JSON.parse(token) : null;
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': parsedToken?.token ? `Bearer ${parsedToken.token}` : ''
    });
  }

  get httpOptionsAuth() {
    return { headers: this.getAuthHeaders() };
  }

  constructor(
    private http: HttpClient,
  ) { }

  getToken(payload: any): Promise<tokenResponse> {
    return firstValueFrom(
      this.http.post<tokenResponse>(
        constants.IAPI_ENDPOINT + '/meeting/room',
        JSON.stringify(payload),
        this.httpOptionsAuth)
      );
  }
}
